import React from 'react';
import { Send } from 'lucide-react';

export default function Contact() {
  return (
    <section id="contact" className="py-20 bg-surface">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden flex flex-col md:flex-row">
          
          <div
            className="w-full md:w-1/2 p-8 md:p-12 bg-brand text-white flex flex-col justify-between"
            style={{
              backgroundColor: "#6b7d5d"
            }}>
            <div>
              <h2 className="text-3xl font-bold mb-6">Contact Us</h2>
              <p
                className="text-brand-light/90 mb-8 leading-relaxed"
                style={{
                  color: "#ffffff"
                }}>
                Have questions about our services or want to schedule a pickup? 
                Send us a message and we'll get back to you shortly.
              </p>
            </div>
            <div className="space-y-2 text-sm text-brand-light/80">
              <p
                style={{
                  color: "#ffffff"
                }}>Mon - Fri: 8:30 AM - 6:00 PM</p>
              <p
                style={{
                  color: "#ffffff"
                }}>Sat: 9:00 AM - 2:00 PM</p>
              <p
                style={{
                  color: "#ffffff"
                }}>Sun: Closed</p>
            </div>
          </div>

          <div className="w-full md:w-1/2 p-8 md:p-12">
            <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                <input 
                  type="text" 
                  id="name" 
                  className="w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-200 focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none transition-all"
                  placeholder="Your Name"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input 
                  type="email" 
                  id="email" 
                  className="w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-200 focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none transition-all"
                  placeholder="your@email.com"
                />
              </div>
              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                <input 
                  type="tel" 
                  id="phone" 
                  className="w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-200 focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none transition-all"
                  placeholder="(555) 123-4567"
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                <textarea 
                  id="message" 
                  rows={4}
                  className="w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-200 focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none transition-all resize-none"
                  placeholder="How can we help you?"
                ></textarea>
              </div>
              <button 
                type="submit" 
                className="w-full bg-brand text-white font-bold py-4 rounded-lg hover:bg-brand-dark transition-colors shadow-lg flex items-center justify-center gap-2"
              >
                Send Message
                <Send size={18} />
              </button>
            </form>
          </div>

        </div>
      </div>
    </section>
  );
}
